/* eslint-disable no-useless-escape */
import {featureAccessDeniedContent, roleAccessDeniedContent, timeZoneAllData} from 'constants/variables'
import _ from 'lodash'
import moment from 'moment-timezone'
import {getUserInfo} from './local-storage'

const subDomainRegex = /(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/i

export const urlBase64ToUint8Array = base64String => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)

  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/')

  const rawData = window.atob(base64)

  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i)
  }

  return outputArray
}

export const unregisterServiceWorkers = async () => {
  try {
    const registrations = await navigator.serviceWorker.getRegistrations()
    for (const registration of registrations) {
      if (registration.scope.includes('/support')) {
        await registration.unregister()
      }
    }
  } catch (error) {
    // console.error(error)
  }
}

export const get = (a, b, c) => {
  const retValue = c !== undefined ? c : null
  return a.reduce((obj, key) => (obj && key && obj[key] !== null && obj[key] !== undefined ? obj[key] : retValue), b)
}

export function wrapText(str, limit) {
  // eslint-disable-next-line no-nested-ternary
  return str ? (str.length > limit ? str.substring(0, limit).concat('...') : str) : str
}

export function GetFormattedDate(date) {
  const isToday = someDate => {
    const today = new Date()
    return (
      someDate.getDate() === today.getDate() &&
      someDate.getMonth() === today.getMonth() &&
      someDate.getFullYear() === today.getFullYear()
    )
  }

  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  const dt = new Date(date)

  let day = dt.getDate()
  let hr = dt.getHours()
  let min = dt.getMinutes()
  let postfix

  if (day < 10) {
    day = `0${day}`
  }
  if (hr < 12 && hr >= 0) postfix = 'am'
  if (hr <= 23 && hr >= 12) postfix = 'pm'
  if (hr > 12 && hr <= 23) hr %= 12
  if (hr < 10) hr = `0${hr}`
  if (min < 10) min = `0${min}`

  if (isToday(dt)) {
    return `${hr}:${min} ${postfix}`
  }

  return `${monthNames[dt.getMonth()]} ${day}`
}

export function extractTextContentFromHTML(s) {
  const span = document.createElement('span')
  span.innerHTML = s
  return span.textContent || span.innerText
}

export const copyToClipboardWithoutInput = (str, setSuccess) => {
  const el = document.createElement('textarea')
  el.value = str
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
  setSuccess('Copied')
}

export function copyToClipboard(e, textAreaRef, setCopySuccess) {
  if (textAreaRef.current) {
    textAreaRef.current.select()

    try {
      document.execCommand('copy')
      setCopySuccess('Copied')
    } catch (err) {
      //
    }
    // This is just personal preference.
    // I prefer to not show the the whole text area selected.
    e.target.focus()
  }
}

export function adjustTimeUnit(seconds) {
  const time = seconds / 60
  if (time > 1 && time < 60) {
    return (
      <>
        {time.toFixed(2)}
        <small className="ml-2">Mins</small>
      </>
    )
  }
  if (time >= 60 && time < 1440) {
    return (
      <>
        {(time / 60).toFixed(2)}
        <small className="ml-2">Hours</small>
      </>
    )
  }
  if (time >= 1440) {
    return (
      <>
        {(time / (60 * 24)).toFixed(2)}
        <small className="ml-2">Days</small>
      </>
    )
  }
  return (
    <>
      {seconds}
      <small className="ml-2">Secs</small>
    </>
  )
}

export const getBadgeColorPriority = priority => {
  if (priority === 'low') {
    return 'green'
  }
  if (priority === 'medium') {
    return 'olive'
  }
  if (priority === 'high') {
    return 'orange'
  }
  if (priority === 'critical') {
    return 'red'
  }
}

export function cleanUpObject(jsonObject) {
  Object.keys(jsonObject).forEach(function (key) {
    const currentObj = jsonObject[key]

    if (_.isNull(currentObj) || currentObj === '') {
      delete jsonObject[key]
    } else if (_.isObject(currentObj)) {
      if (_.isArray(currentObj)) {
        if (!currentObj.length) {
          delete jsonObject[key]
        } else {
          const cleanupArrayObj = []
          for (const obj of currentObj) {
            if (!_.isNull(obj) || currentObj !== '') {
              const cleanObj = cleanUpObject(obj)
              if (!_.isEmpty(cleanObj)) {
                cleanupArrayObj.push(cleanObj)
              }
            }
          }
          if (!cleanupArrayObj.length) {
            delete jsonObject[key]
          } else {
            jsonObject[key] = cleanupArrayObj
          }
        }
      } else if (_.isEmpty(Object.keys(jsonObject[key]))) {
        delete jsonObject[key]
      } else {
        jsonObject[key] = cleanUpObject(currentObj)

        if (_.isEmpty(Object.keys(jsonObject[key]))) {
          delete jsonObject[key]
        }
      }
    }
  })

  return jsonObject
}

export const newTimeZoneData = Object.values(timeZoneAllData.countries).map(function (elem) {
  return {
    country: elem.name,
    timezone: elem.zones[0],
  }
})

export const secondsToMoment = s => {
  return moment.utc(s * 1000).format('HH:mm:ss')
}

export const onIdealUser = ({timeOut = 30000, onIdeal = () => {}}) => {
  let time
  function ideal() {
    onIdeal()
    document.onmousemove = () => {}
    document.onkeypress = () => {}
  }

  function resetTimer() {
    clearTimeout(time)
    time = setTimeout(ideal, timeOut)
    // 1000 milliseconds = 1 second
  }
  window.onload = resetTimer
  // DOM Events
  document.onmousemove = resetTimer
  document.onkeypress = resetTimer
}

export const capitalize = str => `${str.charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}`

export const startCase = string => {
  return _.startCase(string)
}

export const removeDoubleQuotes = string => {
  return capitalize(string.replace(/"/g, ''))
}

export const getService = service => {
  const services = {desk: 'support', crm: 'sales', survey: 'surveys'}
  return services[service] || service
}

export const getPermissionTooltipContent = ({featureAccess, roleAccess}) => {
  if (featureAccess !== undefined && !featureAccess) return featureAccessDeniedContent
  if (roleAccess !== undefined && !roleAccess) return roleAccessDeniedContent
  return null
}

export const getSortType = type => {
  if (type === 'asc') return 'ascending'
  if (type === 'desc') return 'descending'
}

/**
 * Determines if the current navigation link is active.
 * @param {string} path - The path to check against the current location.
 * @param {boolean} [isExact=false] - Whether to check for an exact match or just the start of the path.
 * @returns {boolean} - True if the navigation link is active, false otherwise.
 */
export const isActiveNavlink = (path, isExact = false) => {
  if (!path) return false
  if (isExact) {
    return window.location.pathname.replace('/support', '') === path
  }
  return window.location.pathname.includes(path)
}

export const getFormattedTime = time => {
  if (!time) return '-'

  const localStorageData = getUserInfo()
  const timezone = localStorageData.timezone || moment.tz.guess()
  const timeFormat = (localStorageData.timeFormat || '12') === '12' ? 'h:mm A' : 'HH:mm'

  const convertedTime = moment.tz(time, timezone).format(timeFormat)

  return convertedTime
}

export const getFormattedDate = date => {
  if (!date) return '-'

  const localStorageData = getUserInfo()
  const timezone = localStorageData.timezone || moment.tz.guess()
  const dateFormat = localStorageData.dateFormat || 'DD MM YYYY'

  const convertedDate = moment.tz(date, timezone).format(dateFormat)

  return convertedDate
}

export const getPathWithPrefix = (prefix, path) => {
  // Ensure the prefix start & ends with a slash and the path doesn't start with a slash
  let formattedPrefix = prefix
  if (!formattedPrefix.startsWith('/')) {
    formattedPrefix = `/${formattedPrefix}`
  }
  if (!formattedPrefix.endsWith('/')) {
    formattedPrefix = `${formattedPrefix}/`
  }

  const formattedPath = path.startsWith('/') ? path.slice(1) : path

  // Combine the prefix and path
  return `${formattedPrefix}${formattedPath}`
}

export const getFullNameFromObj = user => {
  if (!user) {
    throw new Error('Invalid user object')
  }
  return startCase(`${user?.firstName || ''} ${user?.lastName || ''}`)
}

export const getShortNameFromObj = user => {
  if (!user) {
    throw new Error('Invalid user object')
  }
  return `${user?.firstName?.charAt(0)?.toUpperCase()}${user?.lastName?.charAt(0)?.toUpperCase()}`
}

export const generateOptions = items => {
  if (!_.isArray(items)) return []

  return items.map(item => ({
    key: item,
    value: item,
    text: startCase(item),
  }))
}

export const getQueryFilter = queryFilter => {
  if (!queryFilter) return ''
  const qs = Object.keys(queryFilter)
    .filter(key => queryFilter[key] && queryFilter[key] !== 'all')
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryFilter[key])}`)
    .join('&')
  return qs
}

export function isNotBooleanOrNull(value) {
  return typeof value !== 'boolean' && value !== null && value !== undefined
}

export const updateSorting = (column, setState) => {
  setState(prevParams => ({
    ...prevParams,
    sortBy: column,
    sortType: prevParams.sortBy === column && prevParams.sortType === 'asc' ? 'desc' : 'asc',
  }))
}

export function verifySubdomain() {
  return new Promise((resolve, reject) => {
    try {
      let domain

      if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        domain = window.localStorage.getItem('domain')
      } else {
        domain = window.location.hostname.match(subDomainRegex) !== null
      }
      if (!domain) {
        reject(domain)
      }
      resolve(domain)
    } catch (error) {
      reject(error)
    }
  })
}


export const generateIntegrityHash = async url => {
  // Fetch the resource (this should be a public, CORS-enabled file)
  const response = await fetch(url)
  const content = await response.text()

  // Generate a hash (SHA-384)
  const hashBuffer = await crypto.subtle.digest(
    'SHA-384',
    new TextEncoder().encode(content),
  )
  const hashArray = Array.from(new Uint8Array(hashBuffer)) // Convert buffer to byte array
  const hashHex = hashArray
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('')

  // Prefix with 'sha384-' for integrity
  return `sha384-${hashHex}`
}